import { format } from "date-fns";

export const formatDate = (dateString?: string) => {
  let result = dateString
    ? format(new Date(dateString + "Z"), "MMM d, y, hh:mm a")
    : "";

  return result;
};
